import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useUI } from '../../context/UIContext';
import { ROUTES } from '../../constants/routes';
import LoadingSpinner from '../common/LoadingSpinner';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, passedMfa } = useAuth();
  const { isInitialized } = useUI();
  const location = useLocation();

  if (!isInitialized) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <LoadingSpinner />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  if (!passedMfa) {
    return <Navigate to={ROUTES.MFA} state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;